(() => {
  function setup(root) {
    if (!root || root.dataset.nfReady) return;
    root.dataset.nfReady = 'true';
    const gallery = root.querySelector('[data-nf-gallery]');
    const thumbnails = [...root.querySelectorAll('[data-nf-photo]')];
    const thumbnailStrip = root.querySelector('.nf-thumbnails');
    const previous = root.querySelector('[data-nf-prev]');
    const next = root.querySelector('[data-nf-next]');
    const counter = root.querySelector('[data-nf-counter]');
    const moveTo = index => gallery.scrollTo({left: Math.max(0, Math.min(index, thumbnails.length - 1)) * gallery.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', event => { event.preventDefault(); moveTo(index); }));
    previous.addEventListener('click', () => moveTo(Math.round(gallery.scrollLeft / gallery.clientWidth) - 1));
    next.addEventListener('click', () => moveTo(Math.round(gallery.scrollLeft / gallery.clientWidth) + 1));
    gallery.addEventListener('scroll', () => {
      const index = Math.round(gallery.scrollLeft / gallery.clientWidth);
      thumbnails.forEach((thumbnail, i) => thumbnail.setAttribute('aria-current', i === index ? 'true' : 'false'));
      counter.textContent = `${index + 1} / ${thumbnails.length}`;
      previous.disabled = index === 0;
      next.disabled = index === thumbnails.length - 1;
      const selected = thumbnails[index];
      if (selected) {
        const stripRect = thumbnailStrip.getBoundingClientRect();
        const thumbRect = selected.getBoundingClientRect();
        if (thumbRect.left < stripRect.left || thumbRect.right > stripRect.right) thumbnailStrip.scrollTo({left: selected.offsetLeft - thumbnailStrip.offsetLeft - (thumbnailStrip.clientWidth - selected.offsetWidth) / 2, behavior: 'instant'});
      }
    }, {passive: true});
    const form = root.querySelector('.nf-form');
    const buttons = [...root.querySelectorAll('.nf-add')];
    const statuses = [...root.querySelectorAll('[data-nf-status], [data-nf-sticky-status]')];
    const variantSelect = root.querySelector('[data-nf-variant]');
    if (variantSelect) variantSelect.addEventListener('change', () => {
      const option = variantSelect.selectedOptions[0];
      root.querySelectorAll('[data-nf-price]').forEach(price => { price.textContent = option.dataset.price; });
      buttons.forEach(button => { button.disabled = option.dataset.available !== 'true'; });
    });
    function showStatus(message, success) {
      statuses.forEach(status => {
        status.replaceChildren(document.createTextNode(message));
        if (success) {
          const link = document.createElement('a');
          link.href = root.dataset.cartUrl;
          link.textContent = root.dataset.view;
          status.appendChild(link);
        }
      });
    }
    let busy = false;
    form.addEventListener('submit', async event => {
      if (event.submitter && !event.submitter.classList.contains('nf-add')) return;
      if (!window.fetch) return;
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      busy = true;
      buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = root.dataset.adding; });
      statuses.forEach(status => { status.replaceChildren(); });
      try {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + 'cart/add.js', {method: 'POST', headers: {Accept: 'application/json'}, body: new FormData(form)});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.error);
        showStatus(root.dataset.added, true);
        window.setTimeout(() => root.querySelector('[data-nf-sticky-status]').replaceChildren(), 6000);
        try {
          const cartResponse = await fetch(base + 'cart.js', {headers: {Accept: 'application/json'}});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            root.querySelectorAll('[data-nf-cart-count]').forEach(count => { count.textContent = String(cart.item_count); });
          }
        } catch {}
      } catch (error) {
        showStatus(error.message || root.dataset.error, false);
      } finally {
        busy = false;
        buttons.forEach(button => {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.replaceChildren(document.createTextNode(root.dataset.add));
          const arrow = document.createElement('span');
          arrow.setAttribute('aria-hidden', 'true'); arrow.textContent = '↗'; button.appendChild(arrow);
        });
      }
    });
  }
  const start = () => document.querySelectorAll('[data-nf-root]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
  document.addEventListener('shopify:section:load', start);
})();

